import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Loader } from '@googlemaps/js-api-loader';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { Message } from 'primeng/api';
import { BaseService } from '../../../shared/services/base.service';
import { ConstantsService } from '../../../shared/services/constants.service';
import { PermitToWorkConstantsService } from '../../services/permittowork-constants.service';
import { PermitToWorkService } from '../../services/permittowork.service';

@Component({
  selector: 'ara-permit-map-view',
  templateUrl: './permit-map-view.component.html',
  styleUrls: ['./permit-map-view.component.css']
})
export class PermitMapViewComponent implements OnInit {
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  googleMap: google.maps.Map;
  permitStatusTable: any = [];
  permitTypeTable: any = [];
  mapMessage: Message[] = [{ severity: "info", summary: 'Click on marker to view list of Permits.To navigate to Permit Page,click on Permit No from popup.' },
  { severity: "warn", summary: 'Some permits don\'t have Exact Location in Lat, Long format. These will not be shown in map.' }];
  independentPermissions: any;
  showPermit : boolean = false;
  permitData : any = [];

  constructor(
    private baseService: BaseService,
    private ptwService: PermitToWorkService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.routesFlag = PermitToWorkConstantsService.PTWNavigation.InnerRoutes;
    this.reportRoutes = PermitToWorkConstantsService.PTWNavigation.ReportRoutes;
    let map = new Loader({
      apiKey: ConstantsService.URL.MAP_KEY
    });
    // map.load().then(() => {
    //   this.googleMap = new google.maps.Map(document.getElementById("mapChart"), {
    //     zoom: 6,
    //     center: { lat: 23.614328, lng: 58.545284 }
    //   });
    //   this.mapData("Active");
    // });
    this.mapData("Active");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    if (!this.independentPermissions.PTW_Add && !this.independentPermissions.PTW_Add_Unit && !this.independentPermissions.PTW_Admin && !this.independentPermissions.PTW_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === 'Apply Permit') {
          this.routesFlag.splice(index, 1);
        }
      }
    }

  }

  LoadMap()
  {
    let map = new Loader({
      apiKey: ConstantsService.URL.MAP_KEY
    });
    map.load().then(() => {
      this.googleMap = new google.maps.Map(document.getElementById("mapChart"), {
        zoom: 6,
        center: { lat: 23.614328, lng: 58.545284 }
      });
    });
  }
  mapData(status): void {
    this.LoadMap();
    let markers = [];
    let locations : any = []; 
    this.baseService.showRootLoader = true;
    this.ptwService.getPermitDataForMap().subscribe(res => {
      if (res.Success && res.Result && res.Result.length > 0) {
        this.permitStatusTable = [];
        this.permitTypeTable = [];
        let groupedData = this.groupBy(res.Result, r => r.Status);
        let count = 0;
        groupedData.forEach((group) => {
          this.permitStatusTable.push({
            Status: group[0].Status,
            Count: group.length
          });
          count += group.length;
        });
        this.permitStatusTable.push({
          Status: 'Total',
          Count: count
        });
        count = 0;
        let groupedDataForPermitType = this.groupBy(res.Result, r => r.PermitType);
        groupedDataForPermitType.forEach((group) => {
          this.permitTypeTable.push({
            PermitType: group[0].PermitType == 1 ? 'Red Edge Permit' : group[0].PermitType == 2 ? 'Blue Edge Permit' : 'No Work Permit',
            Count: group.length
          });
          count += group.length;
        });
        this.permitTypeTable.push({
          PermitType: 'Total',
          Count: count
        });
        if(status == "Total")
        {
          locations = res.Result.filter(d => d.lat && d.lng);
        }
        else
        {
          locations = res.Result.filter(d => d.lat && d.lng && d.Status == status);
        }
        locations = locations.map(d => ({
          ...d,
          id: d.PermitId,
          content: `<div class="${this.getClassName(d.PermitType)}"><strong>${d.PermitNumber}</strong><br><label>${d.Status}</label></div>`
        }));

        locations.forEach((loc, i) => {
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(loc.lat, loc.lng),
            map: this.googleMap
          });

          var infowindow = new google.maps.InfoWindow({
            content: loc.content
          });
          markers.push(marker);
          // Now we are inside the closure or scope of this for loop,
          // but we're calling a function that was defined in the global scope.
          this.addMarkerListener(marker, infowindow, loc);
        });
        var options = {
          imagePath: 'assets/images/google-maps/m',
          averageCenter: true
        };
        const markerCluster = new MarkerClusterer(this.googleMap, markers, options);
        google.maps.event.addListener(markerCluster, "click", (e) => {
          let locData : any = [];
          this.permitData = [];
          var m = e.getMarkers();
          m.forEach(element => {
           var lat = element.getPosition().lat();
           var lng = element.getPosition().lng();
           let dupLocation = locData.length < 1 ? 0 : locData.filter(d => d.lat == lat && d.lng == lng).length;
           if(dupLocation < 1)
           {
            let data = {lat:lat,lng:lng};
            locData.push(data);
           }
          }); 
          let locationData : any = [];
          if(locData.length > 0)
          {
            locData.forEach(element => {
              locationData = locations.filter(d => d.lat == element.lat && d.lng == element.lng);
              locationData.forEach(element => {
                this.permitData.push(element);
              });
              locationData = [];
            });
          }
          this.showPermit = true;
        });
        google.maps.event.addListener(markerCluster, "mouseout", (e) => {
        });
      }
      this.baseService.showRootLoader = false;
    });
  }

  // We have to define this function outside the scope of the above for loop,
  // so we define is here in the global scope. If your application is large,
  // you probably don't want to put this in the global scope - to preserve
  // the global namespace.
  addMarkerListener(marker, infowindow, loc): void {
    // marker.addListener('mouseover', (e) => {
    //   infowindow.open(this.googleMap, marker);
    // });

    // marker.addListener('mouseout', (e) => {
    //   infowindow.close();
    // });

    // marker.addListener('dblclick', (e) => {
    //   this.router.navigate(['/ptw/raise-permit', loc.PermitId]);
    // });
    marker.addListener('click', (e) => {
      this.permitData = [];
      this.permitData.push(loc);
      this.showPermit = true;
    });
  }

  getClassName(permitType): string {
    switch (permitType) {
      case 1:
        return 'red-edge-permit'
      case 2:
        return 'blue-edge-permit'
      case 3:
        return 'black-edge-permit'
    }
  }
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  Redirect(value)
  {
  this.router.navigate(['/ptw/raise-permit/'+value]);
  }

}
